import { supabase } from '@/integrations/supabase/client';

const cache = new Map<string, Promise<boolean>>();

/**
 * Direct contact (phone / WhatsApp) is allowed for private sellers and for
 * dealers with an active subscription. Unpaid dealers receive buyers only
 * through platform requests.
 */
export function canDirectContact(sellerId?: string | null): Promise<boolean> {
  if (!sellerId) return Promise.resolve(true);
  let p = cache.get(sellerId);
  if (!p) {
    p = (async () => {
      const { data: dp } = await supabase
        .from('dealer_profiles').select('user_id').eq('user_id', sellerId).maybeSingle();
      if (!dp) return true;
      const { data } = await supabase.rpc('is_user_subscribed', { _uid: sellerId });
      return data === true;
    })().catch(() => true);
    cache.set(sellerId, p);
  }
  return p;
}
